import { useNavigate } from 'react-router-dom';
import { useAddLmsTrainingCatalogMutation, useUpdateLmsTrainingCatalogMutation, useDeleteLmsTrainingCatalogMutation } from '../../../../../api';
import toastService from '../../../../../utils/toastService';
import { formatErrorMessage } from '../../../../../utils/errorUtils';
import { useLanguage } from '../../../../../contexts/LanguageContext';

/**
 * `TrainingCatalogCreateEdit` sayfasının kaydet/sil mutasyonları. Liste sayfasının
 * filtre/sayfalama state'i `hooks/useTrainingCatalogData.js` içinde — düzenleme sayfası artık
 * o hook'u import etmiyor (claim modülündeki `useWarrantyClaimsMutations` ayrımıyla aynı desen).
 */
const useTrainingCatalogMutations = () => {
    const { th } = useLanguage();
    const navigate = useNavigate();

    const [addMutation, { isLoading: isCreating }] = useAddLmsTrainingCatalogMutation();
    const [updateMutation, { isLoading: isUpdating }] = useUpdateLmsTrainingCatalogMutation();
    const [deleteMutation, { isLoading: isDeleting }] = useDeleteLmsTrainingCatalogMutation();

    const saveTraining = async (payload, isEdit) => {
        try {
            if (isEdit) {
                await updateMutation(payload).unwrap();
                toastService.success(th('trainingCatalog.saveSuccess'), th('common.success'));
                return { success: true };
            }
            const result = await addMutation(payload).unwrap();
            toastService.success(th('trainingCatalog.saveSuccess'), th('common.success'));
            return { success: true, newId: result?.data?.id ?? null };
        } catch (err) {
            toastService.error(formatErrorMessage(err) || th('trainingCatalog.saveError'), th('common.error'));
            return { success: false };
        }
    };

    const deleteTraining = async (id) => {
        try {
            await deleteMutation(id).unwrap();
            toastService.success(th('trainingCatalog.deleteSuccess'), th('common.success'));
            navigate('/learning-management-system/training-catalog');
            return true;
        } catch (err) {
            toastService.error(formatErrorMessage(err) || th('trainingCatalog.deleteError'), th('common.error'));
            return false;
        }
    };

    return {
        saveTraining,
        deleteTraining,
        isCreating,
        isUpdating,
        isDeleting
    };
};

export default useTrainingCatalogMutations;
